module.exports = __webpack_public_path__ + "d78273735947f69f7f1f1172519efde4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/wsxx.png
// module id = 286
// module chunks = 0